export default "__VITE_ASSET__CHQ3lgg6__"